import { Instance, types } from 'mobx-state-tree';

const CuratorProgramGroup = types.model('CuratorProgramGroup', {
	id: types.identifierNumber,
	curator_id: types.maybeNull(types.number),
	program_group_id: types.maybe(types.number),

	has_group_channels: types.boolean,
	has_group_channels_teacher: types.boolean,

	has_channel_channels: types.boolean,
	has_channel_channels_teacher: types.boolean,

	has_messaging_channels: types.boolean,

	created_at: types.maybe(types.string),
	updated_at: types.maybe(types.string),
});

export default CuratorProgramGroup;

export interface ICuratorProgramGroupModel extends Instance<typeof CuratorProgramGroup> {}
